var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnalyticsTabSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.46094 39.4644V0.074646H0V41.9253H42V39.4644H2.46094Z",
    fill: "#00BAC7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.64844 11.2222H13.7578V36.2768H5.64844V11.2222Z",
    fill: "#00BAC7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9453 5.57379H25.0547V36.2769H16.9453V5.57379Z",
    fill: "#00BAC7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2422 16.9453H36.3516V36.2768H28.2422V16.9453Z",
    fill: "#00BAC7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsTabSelected);
export default __webpack_public_path__ + "static/media/analytics-tab-selected.a0cdf6af.svg";
export { ForwardRef as ReactComponent };